import React from "react";

export interface ResourceHeaderProps<TResource extends object = object> {
	label: React.ReactNode;
	index: number;
	resource: TResource;
}

export default function ResourceHeader<TResource extends object = object>({ label }: ResourceHeaderProps<TResource>) {
	return <>{label}</>;
}
